import { child, set, onValue, update, remove, getDatabase , ref as refDb,} from 'firebase/database';
import { PiniaPluginContext } from 'pinia'
import { usePosStore } from '../stores/pos';
import { useEmployeePinStore } from '~/modules/setting/stores/employeePin';
import { useServerTime } from '~/modules/core/utils/timestamp';
import dayjs from 'dayjs';
import { RunMode } from '~~/interface/Pos';

// คำขอพิมพ์ใบแจ้งยอดจากมือถือ (stores/{id}/requestPrintPreview/{table}) — Main Cashier รับคนเดียว
// ของเดิมทุกเครื่อง (main / 2nd / terminal) ฟัง node เดียวกัน เครื่องไหนเห็นทันก็พิมพ์ + ล็อคโต๊ะ
// = พิมพ์ซ้ำหลายเครื่อง และเครื่องที่เพิ่งบูตลบคำขอที่ Main Cashier ยังไม่ได้พิมพ์ทิ้ง (clearData)
// เช็คโหมดตอนคำขอมาถึง ไม่ใช่ตอนสร้าง store (โหมดอาจยังโหลดไม่เสร็จ — เหตุผลเดียวกับ mobile.items.plugin.ts)
const isMainCashier = () => useRunningMode().getMode() === RunMode.MAIN_CASHIER

function MyPiniaPlugin({ store }: PiniaPluginContext) {
           
          if (store.$id == 'pos') {  
            const DELAY = 3 // seconds
            
            setTimeout(() => { 
              if (isMainCashier()) clearData()
              runRequestPrint();
              }, 1000 * DELAY)
          }
    
     
}

function runRequestPrint(){
        const posStore = usePosStore()
        let fbInstance = useFirebase();
        let tablesStateRef = fbInstance.printPreviewRequestRef();
       

        onValue(tablesStateRef, (snapshot) => {
          if (!isMainCashier()) return;
          if (snapshot.exists()) {
            const value = snapshot.val();  
           
            let updateData = {}
            Object.entries(value).forEach(([tableName, data]) => {  
              if(data){                   
                let serverTime = useServerTime().getCorrectedDayjsInstance()               
                let requestTime = dayjs(data?.timestamp);
                const diff = serverTime.diff(requestTime, 'seconds');  
               

                if (Math.abs(diff) < 10) {  
                  console.info("REQUEST PRINT PREVIEW......=======")
                  posStore.printPreviewFromMobile(tableName, data?.employee)
                }

                updateData[tableName] = null               
              }     
            });

            update(tablesStateRef, updateData);     
          } 
        }, (error) => {
          console.error("Error listening to tablePrint value:", error);
        });
}

function clearData(){
  let fbInstance = useFirebase();
  let tablesStateRef = fbInstance.printPreviewRequestRef();
  remove(tablesStateRef)
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MyPiniaPlugin)
})
